import { render } from "./creditos.vue?vue&type=template&id=562e91da&scoped=true"
import script from "./creditos.vue?vue&type=script&lang=js"
export * from "./creditos.vue?vue&type=script&lang=js"

import "./creditos.vue?vue&type=style&index=0&id=562e91da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562e91da"]])

export default __exports__